// NPM Imports
import React from 'react'
// Quote Context
import { useQuoteContext } from '../../../hooks/useQuoteContext'
import { productType } from '../../../types/types'
//@ts-ignore
import { MultiProductDropdownTable } from '../../ui-helper-elements'

function ProfessionalServicesTable() {
   //TODO: change this to the proper typing once we migrate App.jsx to Typescript
   const state = useQuoteContext()
   const { getString } = state

   // Filter the product list to get only the Professional Services products with monthly billing frequency sorted by DisplayOrder
   const serviceList = (Object.values(state.product_list) as productType[])
      .filter((product) => {
         return (
            product.ProductFamily === 'Professional Services' &&
            product.BillingFreq === 'once' &&
            (product.RoleRequired === null ||
               product.RoleRequired.split(',').includes(state.user_role) ||
               state.professionalServiceDetails.some(
                  (service) => service.serviceCode === product.ProductCode,
               ))
         )
      })
      .sort(
         (a: productType, b: productType) =>
            (a.DisplayOrder ?? 0) - (b.DisplayOrder ?? 0),
      )

   if ((state?.professionalServiceDetails?.length ?? 0) > 0) {
      return (
         <MultiProductDropdownTable
            tableTitle={getString(
               'product.ProfessionalServicesTable.TableTitle',
            )}
            productList={serviceList}
            detailsList={state.professionalServiceDetails}
            handleDetailsChange={(updatedList) =>
               state.setProfessionalServiceDetails(
                  updatedList as {
                     serviceCode: string
                     count: number
                     [key: string]: string | number
                  }[],
               )
            }
            codeField='serviceCode'
            currencyObject={state.currencyObject}
         />
      )
   }
}

export default ProfessionalServicesTable
